import type { RequestParams } from './utils/api';
import { fetchPhrases } from './utils/api';
import { addDBPhrases, checkDB } from './utils/db';

export type TranslatePhrasesOptions = {
  phrases: string[];
  params: RequestParams;
  storeFilter?: (value: string) => boolean;
};

export async function translatePhrases({
  phrases,
  params,
  storeFilter = () => true
}: TranslatePhrasesOptions): Promise<string[]> {
  const finalPhrases = [...new Set(phrases)];

  const translated = await checkDB(
    finalPhrases,
    params?.language || params?.targetLanguage
  );

  const missing = finalPhrases.filter(
    (p) => !(p in translated) && !Number(p) && !/^\d+$/.test(p)
  );

  if (missing.length > 0) {
    const translatedResponse = await fetchPhrases(missing, params);

    missing.forEach((phrase, i) => {
      translated[phrase] = translatedResponse.phrases[i];
    });

    const storable = Object.fromEntries(
      Object.entries(translated).filter(([phrase]) => storeFilter(phrase))
    );

    await addDBPhrases(
      storable,
      translatedResponse.language.source,
      params?.language || params?.targetLanguage
    );
  }

  return phrases.map((phrase) => translated[phrase] || phrase);
}
